import { render, staticRenderFns } from "./price-input.vue?vue&type=template&id=463cc2a4&"
import script from "./price-input.vue?vue&type=script&lang=js&"
export * from "./price-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports